import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Drawer, Stack } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// config
import { NAV } from '../../../config-global';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
//
import useNavConfig from './useNavConfig';
import NavToggleButton from './NavToggleButton';

// ----------------------------------------------------------------------

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

// const newkey = navConfig[0].items.length;
// const technicalinfonav = [];
// const manualnav = [];
// fetch(`${process.env.REACT_APP_BACKEND_SERVER}/technicalinformation`)
//   .then((response) => response.json())
//   .then((data) => {
//     let currentprimarycategory = '';
//     let currentsecondarycategory = '';
//     let tempprimarynav;
//     let tempsecondarynav;
//     // eslint-disable-next-line no-plusplus
//     for (let i = 0; i < data.length; i++) {
//       if (data[i].primarycategory !== currentprimarycategory) {
//         if (tempprimarynav !== undefined) {
//           tempprimarynav.children.push(tempsecondarynav);
//           technicalinfonav.push(tempprimarynav);
//         }
//         tempprimarynav = {
//           title: data[i].primarycategory,
//           path: '',
//           children: [],
//         };

//         tempsecondarynav = {
//           title: data[i].secondarycategory,
//           path: '',
//           children: [
//             {
//               title: data[i].title,
//               path: `/dealerportal/technicalinformation/view/${data[i].id}`,
//             },
//           ],
//         };
//       } else if (data[i].secondarycategory === currentsecondarycategory) {
//         tempsecondarynav.children.push({
//           title: data[i].title,
//           path: `/dealerportal/technicalinformation/view/${data[i].id}`,
//         });
//       } else if (data[i].secondarycategory !== currentsecondarycategory) {
//         tempprimarynav.children.push(tempsecondarynav);

//         tempsecondarynav = {
//           title: data[i].secondarycategory,
//           path: '',
//           children: [
//             {
//               title: data[i].title,
//               path: `/dealerportal/technicalinformation/view/${data[i].id}`,
//             },
//           ],
//         };
//       } else {
//         tempprimarynav.children.push(tempsecondarynav);
//         tempsecondarynav = {
//           title: data[i].secondarycategory,
//           path: '',
//           children: [
//             {
//               title: data[i].title,
//               path: `/dealerportal/technicalinformation/view/${data[i].id}`,
//             },
//           ],
//         };
//       }
//       currentprimarycategory = data[i].primarycategory;
//       currentsecondarycategory = data[i].secondarycategory;
//     }
//     // const newtechnicalinfonav = technicalinfonav.splice(0, 1);

//     tempprimarynav.children.push(tempsecondarynav);
//     technicalinfonav.push(tempprimarynav);
//   });

// fetch(`${process.env.REACT_APP_BACKEND_SERVER}/manuals`)
//   .then((response) => response.json())
//   .then((data) => {
//     let currentprimarycategory = '';
//     let currentsecondarycategory = '';
//     let tempprimarynav;
//     let tempsecondarynav;
//     // eslint-disable-next-line no-plusplus
//     for (let i = 0; i < data.length; i++) {
//       if (data[i].manualprimarycategory !== currentprimarycategory) {
//         if (tempprimarynav !== undefined) {
//           tempprimarynav.children.push(tempsecondarynav);
//           manualnav.push(tempprimarynav);
//         }
//         tempprimarynav = {
//           title: data[i].manualprimarycategory,
//           path: '',
//           children: [],
//         };
//         tempsecondarynav = {
//           title: data[i].manualsecondarycategory,
//           path: '',
//           children: [
//             {
//               title: `${data[i].make} - ${data[i].model}`,
//               path: `/dealerportal/manuals/view/${data[i].id}`,
//             },
//           ],
//         };
//       } else if (data[i].manualsecondarycategory === currentsecondarycategory) {
//         tempsecondarynav.children.push({
//           title: `${data[i].make} - ${data[i].model}`,
//           path: `/dealerportal/manuals/view/${data[i].id}`,
//         });
//       } else if (data[i].manualsecondarycategory !== currentsecondarycategory) {
//         tempprimarynav.children.push(tempsecondarynav);
//         tempsecondarynav = {
//           title: data[i].secondarycategory,
//           path: '',
//           children: [
//             {
//               title: data[i].title,
//               path: `/dealerportal/manuals/view/${data[i].id}`,
//             },
//           ],
//         };
//       } else {
//         tempprimarynav.children.push(tempsecondarynav);
//         tempsecondarynav = {
//           title: data[i].manualsecondarycategory,
//           path: '',
//           children: [
//             {
//               title: data[i].title,
//               path: `/dealerportal/manuals/view/${data[i].id}`,
//             },
//           ],
//         };
//       }
//       currentprimarycategory = data[i].manualprimarycategory;
//       currentsecondarycategory = data[i].manualsecondarycategory;
//     }
//     tempprimarynav.children.push(tempsecondarynav);
//     manualnav.push(tempprimarynav);
//     // const newtechnicalinfonav = technicalinfonav.splice(0, 1);
//   });

// let updatednav;
// // eslint-disable-next-line prefer-const
// updatednav = { title: 'Technical Information', path: '', children: technicalinfonav };

// navConfig[0].items[10] = updatednav;

// const updatednav2 = { title: 'Manuals', path: '', children: manualnav };
// navConfig[0].items[11] = updatednav2;

export default function NavVertical({ openNav, onCloseNav }) {
  const navConfig = useNavConfig();

  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
        }}
      >
        <Logo />

        {/* <NavAccount/> */}
      </Stack>

      <NavSectionVertical data={navConfig} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              bgcolor: 'transparent',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
